import College from './college';
import Cmty from './cmty';
import Contact from './contact';
import Hero from './hero';
import Layout from './layout';
import Parallax from './parallax';
import Pricing from './pricing';
import Process from './process';
import SliderHero from './slider-hero';
 
export{
  College,
  Cmty,
  Contact,
  Hero,
  Layout,
  Parallax,
  Pricing,
  Process,
  SliderHero,
}
// import {College, Community, Contact,Hero, Layout, Parallax, Pricing, Process, Slider} from './section'